import { useSelector } from 'react-redux';
import { AddIcon } from '@chakra-ui/icons';

export default function DashboardServiceAddServiceCardButton() {
    const { colorScheme } = useSelector((state) => state.settings);
    return <AddIcon boxSize={'38px'} color={`${colorScheme}.500`} />;
}
